var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMatchProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMatchProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.0%",
    y: "-14.0%",
    width: "132.0%",
    height: "132.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.147107111 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.8219328,20.72466 C8.11336074,23.6339501 8.11646226,28.3043135 10.8219328,31.2159056 L21.8693073,43.1072469 C21.977802,43.2249688 22.1287233,43.2916667 22.2866049,43.2916667 C22.4444866,43.2916667 22.5954078,43.2249688 22.7039026,43.1072469 C26.3898834,39.1480744 30.0742279,35.1843922 33.7602375,31.2251313 C36.4688097,28.3157911 36.4688097,23.6432082 33.7602375,20.7338709 C31.0516941,17.8245366 26.6240193,17.8244717 23.9154471,20.7338709 L22.2910849,22.474739 L20.6667515,20.72466 C19.3124509,19.2699914 17.5228756,18.5416667 15.7398478,18.5416667 C13.95682,18.5416667 12.1762046,19.2699884 10.8219328,20.72466 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5004035,9.78393636 C30.2213555,11.106341 30.2228201,13.2292334 31.5004035,14.5526844 L36.7172192,19.9578395 C36.7684528,20.0113495 36.8397212,20.0416667 36.9142764,20.0416667 C36.9888316,20.0416667 37.0601,20.0113495 37.1113336,19.9578395 C38.8519357,18.1582156 40.5917651,16.3565419 42.3323807,14.5568779 C43.6114286,13.2344505 43.6114286,11.1105492 42.3323807,9.78812315 C41.0533463,8.46569845 38.9624998,8.46566898 37.6834519,9.78812315 L36.9163919,10.5794268 L36.1493456,9.78393636 C35.5098148,9.12272334 34.6647375,8.79166667 33.8227522,8.79166667 C32.9807669,8.79166667 32.1399207,9.122722 31.5004035,9.78393636 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icMatchProfile",
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-4-Copy-2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7BCB45",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "path-1",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "path-3",
    fill: "#FFFFFF",
    xlinkHref: "#path-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMatchProfile);
export default __webpack_public_path__ + "static/media/icMatchProfile.6079a2ed3f6e6740f95a641ac286e66b.svg";
export { ForwardRef as ReactComponent };